import { useLocation } from 'react-router-dom';

import { useActiveSubNav } from './useActiveSubNav.ts';

export const useIncludeHeaderBottomPadding = (): boolean => {
  const location = useLocation();
  const activeSubNav = useActiveSubNav();

  // no subnav in orders lists or account settings
  const isOrderPath = location.pathname.startsWith('/order/');
  if (!isOrderPath) return false;

  // need padding with subnav
  return !!activeSubNav;
};
